/*
 *  弹窗 
 * @parmas{
 *      html: dom 传入的组件
 *      opt: Object {
 *          option: Object {//可不传 配置项见Element-ui
 *              width: '50%',
 *              title: '确定',
 *              fullscreen: false,  // 是否全屏
 *              top: String,
 *              modal: Boolean,
 *              showClose: true,
 *              center: 
 *              lockScroll:
 *          },
 *          popup: {
 *              传入组件的对应设置
 *          }
 *      }
 * }
 */
import Vue from 'vue'
import dialogVue from './dialog.vue';
const Modal = function(html, opts = {option: {}, popup: {}}){
    const Popup = Vue.extend(dialogVue);
    const Content = opts.popup.components ? Vue.extend(opts.popup) : null;
    let popup = null;
    const that = {
        create () {
            popup = new Popup().$mount(document.createElement("DIV"));
            popup = Object.assign(popup, opts.option);
            setTimeout(()=>{
                popup.$refs.content.innerHTML = html;
                opts.popup.components && (popup.popup = new Content().$mount(popup.$refs.content));
            }, 100)
        }
    };

    that.create();
    return popup;
};

export default Modal;